import { render, staticRenderFns } from "./PoolbarHeader.vue?vue&type=template&id=4bbbdb9e&scoped=true&"
import script from "./PoolbarHeader.vue?vue&type=script&lang=js&"
export * from "./PoolbarHeader.vue?vue&type=script&lang=js&"
import style0 from "./PoolbarHeader.vue?vue&type=style&index=0&id=4bbbdb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbdb9e",
  null
  
)

export default component.exports